module.exports = __webpack_public_path__ + "img/regularEvent.9ae51c7a.svg";